import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'
import cases from './cases'
import debtors from './debtor'
import apitokens from './apitokens'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'DEBTIA_HOME',
        breadcrumb: [
          {
            text: 'DEBTIA_HOME',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/users/list',
      name: 'users-list',
      component: () => import('@/views/user/users-list/UsersList.vue'),
      meta: {
        pageTitle: 'DEBTIA_USERS',
        breadcrumb: [
          {
            text: 'DEBTIA_USERS',
            active: true,
          },
        ],
        action: constants.action.permissionUserView,
        resource: constants.resource.user,
      },
    },
    // {
    //   path: '/user/get/:id',
    //   name: 'users-view',
    //   component: () => import('@/views/user/users-view/UsersView.vue'),
    //   meta: {
    //     action: constants.action.permissionLogin,
    //     resource: constants.resource.user,
    //   },
    // },
    {
      path: '/user/get/:id',
      name: 'user-edit',
      component: () => import('@/views/user/users-edit/UsersEdit.vue'),
      meta: {
        action: constants.action.permissionUserEdit,
        resource: constants.resource.user,
      },
    },
    {
      path: '/users/add',
      name: 'users-add',
      component: () => import('@/views/user/users-add/UsersAdd.vue'),
      meta: {
        title: 'add users',
        action: constants.action.permissionUserAdd,
        resource: constants.resource.user,
      },
    },
    {
      path: '/role-management',
      name: 'role-management',
      component: () => import('@/views/roles/Roles.vue'),
      meta: {
        pageTitle: 'DEBTIA_ROLE_MANAGEMENT',
        breadcrumb: [
          {
            text: 'DEBTIA_ROLE_MANAGEMENT',
            active: true,
          },
        ],
        action: constants.action.permissionRoleView,
        resource: constants.resource.role,
      },
    },
    {
      path: '/translations/:lang',
      name: 'translations',
      component: () => import('@/views/translations/list/Translations.vue'),
      meta: {
        pageTitle: 'DEBTIA_TRANSLATIONS',
        breadcrumb: [
          {
            text: 'DEBTIA_TRANSLATIONS',
            active: true,
          },
        ],
        navActiveLink: '',
        action: constants.action.permissionTranslationView,
        resource: constants.resource.translation,
      },
    },
    ...cases,
    ...debtors,
    ...apitokens,

    {
      path: '/apisettings',
      name: 'apisettings',
      component: () => import('@/views/apisettings/ApiSettings.vue'),
      meta: {
        pageTitle: 'DEBTIA_API_SETTINGS',
        breadcrumb: [
          {
            text: 'DEBTIA_API_SETTINGS',
            active: true,
          },
        ],
        action: constants.action.permissionUserSettings,
        resource: constants.resource.user,
      },
    },

    {
      path: '/adminsettings',
      name: 'adminsettings',
      component: () => import('@/views/adminsetting/CombinedAdminSettings.vue'),
      meta: {
        pageTitle: 'DEBTIA_ADMIN_SETTINGS',
        breadcrumb: [
          {
            text: 'DEBTIA_ADMIN_SETTINGS',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/reset-password/:token',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  const debtorsBelongToCompany = localStorage.getItem('debtorsBelongTo') === 'company'
  if (isLoggedIn && (to.meta.category === 'debtor' && debtorsBelongToCompany)) {
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  return next()
})

export default router
